import { z } from "zod";

import { commandTokensSchema } from "./command-tokens";
import { computedFieldSchema } from "./field";
import { cardSchema } from "./card";

export const dataMappingConfigurationSchema = z.object({
	version: z.number(),
	initialVersion: z.number(),
	lastUpdated: z.string(),
	tenantId: z.string(),
	importSource: z.string(),
	commands: commandTokensSchema.optional(),
	computedFields: z.array(computedFieldSchema),
	cards: z.array(cardSchema),
	runRulesAfterImport: z.boolean(),
	name: z.string().nullish(),
});
export type DataMappingConfiguration = z.infer<typeof dataMappingConfigurationSchema>;
